import { Datagrid, List, TextField } from 'react-admin';
import { LABELS } from 'shared/constants/labels';

export const DiseasesGroupList = () => {
  return (
    <List pagination={false}>
      <Datagrid bulkActionButtons={false} rowClick="edit">
        <TextField source="name" label={LABELS.name} sortable={false} />
      </Datagrid>
    </List>
  );
};
